module.exports = __webpack_public_path__ + "media/images/fltdental-logo-alt@4x-26feaadc1f2898556efc5c13e8576ea3.png";